<:Window on:resize="resize()" />

<Slide :slide :i>

    <div class="media-outer interactive i-bombs {{ part }}">

        <div class="interactive__layer">

            <div class="i-bombs__map-intro">
                <img alt="bomb map light" class="i-bombs__map-light" src="img/bomb_map_light.jpg" />

                <h5 class="i-bombs__intro-title">Marshall Islands</h5>

                <h6 class="bikini i-bombs__intro-hed i-bombs__intro-hed--majuro"><span class="maj-text">Majuro</span></h6>

                <div class="i-bombs__label--sites">
                    <p class="i-bombs__label--sites-text">U.S. nuclear test sites</p>
                </div>
            </div>

            <div class="atolls i-bombs__atolls" ref:atolls>
                <img alt="Enewetak" class="i-bombs__atolls-active i-bombs__atolls-active--enewetak" src="img/enewetak_active.png" />
                <img alt="Bikini" class="i-bombs__atolls-active i-bombs__atolls-active--bikini" src="img/bikini_active.png" />

                <h6 class="enewetak i-bombs__atolls-hed i-bombs__atolls-hed--enewetak">Enewetak</h6>
                <h6 class="bikini i-bombs__atolls-hed i-bombs__atolls-hed--bikini">Bikini</h6>
            </div>

            <div class="i-bombs__map-main">
                <img alt="bomb map dark" class="i-bombs__map-dark" src="img/bomb_map_dark.jpg" />
            </div>

        </div>

    </div>

    <div class="comparison i-bombs__legend {{ part }}">

        <div class="i-bombs__counter">
            <h6 class="i-bombs__counter-hed"><span class="i-bombs__counter-num">{{ count.toFixed() }}</span><span class="i-bombs__counter-text">Nuclear Bombs</span></h6>
        </div>

        <div class="i-bombs__comparison">
            <p class="i-bombs__comparison-text">
                The size of the Hiroshima bomb was 15 kilotons
            </p>
            {{#if rows.length}}
            <svg style="height: {{ (Math.ceil(yld(15)) * 2) + 1 }}px; width: {{ (Math.ceil(yld(15)) * 2) + 1 }}px;">
                <circle cx="{{ (yld(15)) + 1 }}" cy="{{ (yld(15)) + 1}}" r="{{yld(15)}}"></circle>
            </svg>
            {{/if}}
        </div>
    </div>

    <div class="i-bombs__chart {{ part }}">
        <svg ref:svg class="bombs i-bombs__circles">
            <g transform="translate({{ pad.left }}, {{ pad.top }})">
                {{#each visible as year}}
                <g class="{{ year.key }}" transform="translate({{ offset(year.key) }})" out:fade>
                    {{#each year.values as bomb, i}}
                    <circle in:boom="{ delay: i * delay, duration, i, atoll: bomb.region, year: year.key, reverse }"
                        class="{{ bomb.region }}" 
                        title="{{ bomb.name }}"
                        r="{{ yld(bomb.yield) }}"
                        cx="{{ x(bomb.date.getFullYear(), i) }}"
                        cy="{{ height / 2 }}"></circle>
                    {{/each}}
                </g>
                {{/each}}
            </g>
        </svg>
    </div>

    <div class="i-bombs__timeline-outer {{ part }}">
        <div class="timeline i-bombs__timeline">
            {{#each visible as year}}
            <div class="year" style="width: {{ segment(year.key) * 100 }}%;" transition:fade>
                <span class="label">{{year.key}}</span>
            </div>
            {{/each}}
        </div>
    </div>

    <div class="steps">
        <!-- bullets -->
        <div class="step"></div> <!-- intro -->
        {{#each steps as step}}
        <div class="step"></div> <!-- years -->
        {{/each}}
    </div>
</Slide>


<script>

import Slide from '../Slide.html'
import { bombs } from '../sfx'
import { isReverse } from '../helpers'

import { max } from 'd3-array'
import { csv } from 'd3-fetch'
import { scaleSqrt, scaleBand, scaleLinear } from 'd3-scale'
import { timeParse, timeFormat } from 'd3-time-format'
import { nest } from 'd3-collection'

import { fade } from 'svelte-transitions'
import { tween } from 'svelte-extras'

// hard-code years, since we know them
const YEARS = ["1946", "1948", "1951", "1952", "1954", "1956", "1958"];

const date = {
    parse: timeParse('%Y%m%d'),
    format: String
};

// so we're consistent everywhere
const SLUG = "nukes";
const DELAY = 200;
const DURATION = 400;

function row(d) {
    // return a cleaned row of data
    /* raw columns: 
        date
        origin_t
        id_no
        country
        region
        source
        latitude
        longitude
        mb
        Ms
        depth
        yield_1
        yield_u
        purpose
        name
        type
        date_long
        year
     */
    return {
        date: date.parse(d.date_long),
        region: d.region.toLowerCase(),
        yield: +d.yield_1,
        yield_u: +d.yield_u,
        name: d.name,
    }
}


export default {

    components: { Slide },

    transitions: { 
        fade,

        boom(node, { delay=0, duration=400, i=0, atoll, year, reverse=false }) {

            const r = node.getAttribute('r');
            const sound = bombs[i % bombs.length];

            // short-circuit on reverse
            if (reverse) {
                return {
                    delay: 0,
                    duration,
                    tick: t => node.setAttribute('r', r * t)
                }
            }

            // give time for other transitions
            if (year === YEARS[0]) {
                delay += 750;
            } else {
                delay += 250;
            }

            if (sound && !reverse) {
                setTimeout(sound.play.bind(sound), delay);
            }

            // add class to .atolls for current bomb
            if (atoll) {
                setTimeout(() => {
                    const atolls = document.querySelector(`#${SLUG} .atolls`);

                    atolls.classList.add(atoll);

                    setTimeout(() => {
                        atolls.classList.remove(atoll);
                    }, duration);

                }, delay);
            }

            return {
                delay,
                duration,
                tick: t => node.setAttribute('r', r * t)
            }
        }
    },

    data() {
        return {
            rows: [],
            steps: YEARS,
            width: 0,
            height: 0,
            pad: {top: 0, right: 3, bottom: 0, left: 3},
            count: 0,

            // constants
            slug: SLUG,
            delay: DELAY,
            duration: DURATION,
        }
    },

    computed: {
        years: rows => nest()
            .key(d => d.date.getFullYear())
            .entries(rows),

        year_count: rows => nest()
            .key(d => d.date.getFullYear())
            .rollup(d => d.length)
            .map(rows),

        year_map: rows => nest()
            .key(d => d.date.getFullYear())
            .map(rows),

        visible: (years, i, $bullet) => $bullet[0] === i ? 
            years.slice(0, $bullet[1]) : [],

        part: ($bullet, i, steps) => {

            const [slide, bullet] = $bullet || [];

            if (slide < i) {
                return 'intro';
            }

            if (bullet > steps.length || slide > i) {
                return 'after';
            }

            // make sure comparison catches first
            if (bullet === 0) {
                return 'intro';
            }

            return 'bombs';
        },

        total: rows => rows.length,

        // return a function that calculates a % width for a segment
        segment: (year_count, total) => year => year_count.get(year) / total,

        // get the left offset of a given year
        offset: (segment, steps, width, pad) => year => {
            const prior = steps.slice(0, steps.indexOf(String(year)));

            return prior.map(d => segment(d) * width)
                .reduce((m, d) => m + d, 0);

            //return o + leftpad;
        },

        // calculate position within a given width
        x: (segment, width, year_count, yld) => (year, i) => {
            const space = segment(year) * width;
            const scale = scaleLinear()
                .domain([0, year_count.get(year)])
                .range([0, space]);

            return scale(i);
        },

        // yield is reserved
        yld: (rows, height) => scaleSqrt()
            .domain([0, max(rows, d => d.yield)])
            .range([0, height / 2]),
    },

    oncreate() {
        window.nukes = this;
        this.sfx = bombs;

        csv(window.DATA.nukes, row)
            .then(rows => this.set({ rows }));

        const listener = this.store.observe('bullet', (current, prev) => {
            this.set({ reverse: isReverse(current, prev) });

            if (current[0] === this.get('i')) {
                this.resize();
            }
        });

        this.on('destroy', listener.cancel);

        this.observe('visible', years => {

            if (this.store.get('current_slide') !== this.get('i')) return;

            // get total so far
            const last = years[years.length - 1];
            const count = last ? last.values.length : 0;
            const duration = (count / 2) * this.get('duration');
            const total = years.map(year => year.values)
                .reduce((m, d) => m + d.length, 0);

            // tween update count
            this.tween('count', total, {
                duration,
            });
        });

        this.resize();
    },

    methods: {
        resize() {
            const { width, height } = this.refs.svg.getBoundingClientRect();

            this.set({ width, height });
        },

        tween,
    },

    helpers: {
        isReverse,
    }
}
</script>